<div class="container-fluid mt-3">
    <div
        *ngIf="message"
        class="alert-dismissible fade show text-center"
        [ngClass]="message.cssClass">
        {{ message.text }}
        <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
